/**
 *
 * @param {HTMLInputElement} input
 */
export function showInputError(input) {
  input.classList.add('error')
  const sibling = input.nextElementSibling
  if (sibling && sibling.classList.contains('input-error-container')) {
    const message = input.dataset.errorMessage || ''
    sibling.innerHTML = message
  }
}

/**
 * Must have structure below:

  <div class="input-container">
    <input
      data-error-message="Please Enter Your Full Name"
      data-test="name"
      id="name"
      name="name"
      placeholder="Full Name"
      required
      type="text"
    />
    <div class="input-error-container"></div>
  </div>

 */
